import { Typography, Grid, Container, Button } from '@mui/material';
import React, { useCallback } from 'react';
import { useToastAlert } from "common/alerts";
import { useTableStore } from '../../../state/TableStore';
import { useMUITheme } from '../../../theme/ThemeProvider';

export const AccountReset: React.FC<any> = ({ setOpenDrawer, resendTempPassword, resetPassword, confirmedUser }) => {
    const currentCell = useTableStore(state => state.currentCell)
    const { notifySuccess, notifyError } = useToastAlert();

    const { mode } = useMUITheme();

    const handleResetUserMFA = useCallback(async () => {
        // Reset User MFA API
        setOpenDrawer(false)
        if (currentCell) {
            const resp = await resetPassword(currentCell)
            if (resp.code === 200) {
                notifySuccess(`User's MFA Successfully Reset`, `${currentCell} may attempt to login again`)
            } else {
                notifyError(`Sending Login Email Failed`, `Please try again in a few minutes.`)
            }
        }
    }, [currentCell, notifyError, notifySuccess, setOpenDrawer, resetPassword])

    const handleResendLoginEmail = useCallback(async () => {
        // Will only work when the user's status is FORECE_CHANGE_PASSWORD.
        // Will send a new welcome email with a new password with a new password + expiration date refreshed.
        setOpenDrawer(false)
        if (currentCell) {
            const resp = await resendTempPassword(currentCell)
            if (resp.code === 200) {
                notifySuccess(`Login Email Re-sent`, `${currentCell} will receive an instructional email shortly.`)
            } else {
                notifyError(`Sending Login Email Failed`, `Please try again in a few minutes.`)
            }
        } else {
            notifyError(`Unable to Resend Login Email for ${currentCell}`, `Please try Resetting ${currentCell}'s Password Instead.`)
        }

    }, [currentCell, notifyError, notifySuccess, setOpenDrawer, resendTempPassword])

    return (
        <>
            <Grid sx={{ pl: '1rem', mb: "24px", mt: '1rem' }}>
                <Typography variant='subtitle2' sx={{ mb: '0.5rem', fontSize: '16px' }}>Password and Login Management</Typography>
                <Typography variant='body1'>Ensure any updates to the user's current email
                    address and/or username are made and saved before resetting their password
                    or resending the email.
                </Typography>
            </Grid>
            <Container disableGutters sx={{ display: "flex", flexDirection: "row", pl: '1rem', gap: '1rem' }}>
                <Button variant='outlined' color='primary' sx={{ color: mode === 'dark' ? 'text.primary' : '#430099' }} onClick={() => handleResetUserMFA()} data-testid="reset-user-mfa-button">
                    RESET USER MFA
                </Button>
                <Button variant='outlined' color='primary' sx={{ color: mode === 'dark' ? 'text.primary' : '#430099' }} onClick={() => handleResendLoginEmail()} disabled={confirmedUser} data-testid="resend-login-email-button">
                    RE-SEND LOGIN EMAIL
                </Button>
            </Container>
        </>
    )
}